export const itemTypes = [
    {label: 'Multiple Choice', value: 'MC'},
    {label: 'Open Ended', value: 'OE'},
    {label: 'True/False', value: 'TF'},
    {label: 'Yes/No', value: 'YN'},
    {label: 'Matching', value: 'MATCH'},
    {label: 'Blanks Filling', value: 'FIB'}
];

export const optionCounts = [
    {label: 'ALL', value: 'ALL'},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10}
]

export const difficultyOptions = [
    {label: 'ALL', value: 'ALL'},
    {label: 'Very easy', value: '1'},
    {label: 'Easy', value: '2'},
    {label: 'Moderate', value: '3'},
    {label: 'Hard', value: '4'},
    {label: 'Very hard', value: '5'}
]

export const LETTERS="ABCDEFGHIJKLMNOPQRSTUVWXYZ";